import { render } from "./page_content.vue?vue&type=template&id=74e8b112&scoped=true"
import script from "./page_content.vue?vue&type=script&lang=js"
export * from "./page_content.vue?vue&type=script&lang=js"

import "./page_content.vue?vue&type=style&index=0&id=74e8b112&scoped=true&lang=css"

import exportComponent from "/Users/aaronlin/pushstack/webapp/togs-xlr8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e8b112"]])

export default __exports__